import { memo } from 'react'
import {
  Award,
  Footer,
  Main,
  MedalType,
  Name,
  Points,
  Trophy,
  Year,
} from './_styles'
import LineClamp from '../../LineClamp'

const getRewardNameByType = (rewards, type) => {
  const reward = (rewards || []).find(v => v?.rewardType?.masterName === type)
  return reward?.shortName
}

const AwardItem = ({ award }) => {
  const year = award?.year
  const name = award?.award?.masterNameShort
  const points =
    award?.maxScore !== award?.minScore
      ? `${award?.minScore} - ${award?.maxScore}`
      : award?.maxScore
  const medal = getRewardNameByType(award?.rewards, 'Medal')
  const trophy = getRewardNameByType(award?.rewards, 'Trophy')

  return (
    <Award>
      <Main>
        <Year>{year}</Year>
        <Name>
          <LineClamp lines={2}>{name}</LineClamp>
        </Name>
        <Points>{points}</Points>
      </Main>
      <Footer>
        <MedalType>
          {medal && (
            <>
              <LineClamp lines={1}>{medal}</LineClamp>
              {medal && trophy && ','}
            </>
          )}
        </MedalType>

        <Trophy>{trophy && <LineClamp lines={1}>{trophy}</LineClamp>}</Trophy>
      </Footer>
    </Award>
  )
}

export default memo(AwardItem)
